import img1 from '../../assets/programs/stem_mentorship/DSC01199.JPG'
import img2 from '../../assets/programs/stem_mentorship/DSC01289.JPG'
import img3 from '../../assets/programs/stem_mentorship/DSC01403.JPG'
import img4 from '../../assets/programs/stem_mentorship/DSC01587.JPG'
import img5 from '../../assets/programs/stem_mentorship/DSC01712.JPG'
import img6 from '../../assets/programs/stem_mentorship/DSC02247.JPG'
import img7 from '../../assets/programs/stem_mentorship/DSC02423.JPG'
import img8 from '../../assets/programs/stem_mentorship/DSC02793.JPG'
import img9 from '../../assets/programs/stem_mentorship/DSC02978.JPG'

const stem_mentorship_data = {
    "title": "MANASVI: STEM MENTORSHIP PROGRAMME FOR HIGH SCHOOL GIRLS",
    "description": "A flagship initiative by the Academic Outreach and New Initiatives Office at IIT Delhi to inspire young girls to explore careers in Science, Technology, Engineering and Mathematics (STEM). The objective of the program is to improve the skewed gender ratio in STEM, and imbibe the girls with the right set of skills and mindset to encourage them to pursue careers in STEM. Manasvi aims to go beyond just academic engagement, by offering to these young girls a voice, a platform, and most importantly, a belief that they belong in STEM. For more details: https://youtu.be/0n3j4gK3QWM?si=DOPecXmwGjKtj6dd",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        { "src": img1, "desc": "" },
                        { "src": img2, "desc": "" },
                        { "src": img3, "desc": "" },
                        { "src": img4, "desc": "" },
                        { "src": img5, "desc": "" },
                        { "src": img6, "desc": "" },
                        { "src": img7, "desc": "" },
                        { "src": img8, "desc": "" },
                        { "src": img9, "desc": "" }
                    ]
                }
            ]
        }
    ]
}

export default stem_mentorship_data;